import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Returning from Google sign-in: AuthCallback exchanges the session_id first, so skip the /me check here
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const handleAuth = (data) => {
    localStorage.setItem("homiin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => handleAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) =>
    handleAuth((await api.post("/auth/register", { name, email, password })).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("homiin_token");
    setUser(false);
  };

  const loginWithGoogle = (next, save) => {
    if (next) sessionStorage.setItem("homiin_next", next);
    if (save) sessionStorage.setItem("homiin_save", "1");
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, loginWithGoogle, handleAuth }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
